import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rd-base-progress"},[_c('div',{staticClass:"base-progress-container"},[_c(VProgressLinear,_vm._g(_vm._b({attrs:{"rounded":"","height":_vm.height,"background-color":"var(--grey-800)","value":_vm.normalizedValue}},'v-progress-linear',_vm.$attrs,false),_vm.$listeners)),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }